export function getJalaliSeasonYear() {
    const gregorianDate = new Date(); // Get today's Gregorian date
    let jalaliYear, seasonName;

    // Convert Gregorian year to Jalali year approximately
    // Note: This is a simplified conversion and may not be accurate around the New Year transition period
    jalaliYear = gregorianDate.getFullYear() - 621;

    // Determine the season based on the Gregorian month
    switch (gregorianDate.getMonth()) {
        case 0:
        case 1:
        case 2:
            seasonName = "زمستان";
            break;
        case 3:
        case 4:
        case 5:
            seasonName = "بهار";
            break;
        case 6:
        case 7:
        case 8:
            seasonName = "تابستان";
            break;
        case 9:
        case 10:
        case 11:
            seasonName = "پاییز";
            break;
    }

    // Return formatted string
    return `${seasonName} ${jalaliYear}`;
}
